<div class="notification-body">
  <span>
    {{ 'TGA.Notifications.HeatstressDetectedForCustomer.Description1' | translate }}
  </span>
  @if (notification().cropFieldNames.length > 1) {
    <ul class="bullet-points">
      @for (name of notification().cropFieldNames; track name) {
        <li>
          {{ name }}
        </li>
      }
    </ul>
  }
  <br />
  {{ 'TGA.Notifications.HeatstressDetectedForCustomer.Description2' | translate }}
</div>
